import { api } from "@/api"

type DonationReceipt = {
  receipt: string
}

export type SendOrderReceiptRequest = {
  email?: string
  sms?: string
}

export const retrieveDonationReceipt = async (
  donationId: string
) => {
  const { body } = await api.get<DonationReceipt>(
    `/donations/${donationId}/receipt/`
  )

  return body
}

export const sendDonationReceipt = async (
  donationId: string,
  params: SendOrderReceiptRequest
) => {
  await api.post(`/donations/${donationId}/send-receipt/`, {
    body: params,
  })
}
